<template>
  <div
      class="row row-cols-auto"
      :class="{ 'secondary-style': props.secondaryStyle }"
  >
    <DateRangeInput :showMinute="props.showMinute" />
    <div class="col">
      <label class="form-label">차량번호</label>
      <CarNumWithSearchInput
        :initialCarNum="searchBar.privateCarNum || ''"
        @change="changeCarNum($event)"
        ref="carNumIptRef"
      />
    </div>

    <div class="col d-flex align-items-end search-actions">
      <button class="btn btn-primary shadow-sm refresh-btn" @click="onResetForm" type="button">
        <BIconArrowCounterclockwise/>
      </button>
      <button class="btn btn-primary shadow-sm search-btn" @click="onSubmit" type="button">
        <BIconSearch/>&nbsp;조회
      </button>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {BIconArrowCounterclockwise, BIconSearch} from "bootstrap-icons-vue";
import DateRangeInput from "@/components/tacho/searchbar/DateRangeInput.vue";
import {processSubmits} from "@/components/tacho/searchbar/search-utils";
import CarNumWithSearchInput from "@/components/tacho/searchbar/CarNumWithSearchInput.vue";
import {searchBarProps} from "@/store/searchbar";

const store = useStore();
const initSearchBar = (data) => store.dispatch('initSearchBar', data);
const resetSearchBar = () => store.dispatch('resetSearchBar');
const searchBar = computed(() => store.state.searchBar);
const emit = defineEmits([]);
const props = defineProps({
  secondaryStyle: Boolean,
  onSubmit: Function,
  onSubmitPrivate: Function,
  searchRef: Object,
  showMinute: {
    type: Boolean,
    default: false
  }
});
defineExpose({
  submit: onSubmit,
});
const patchSearchBar = (data) => store.dispatch('patchSearchBar', data);
const carNumIptRef = ref(null);

function onResetForm() {
  if (carNumIptRef.value) {
    carNumIptRef.value.cleanValue();
  }
  resetSearchBar();
}

function changeCarNum(nextCarNum) {
  patchSearchBar({
    prop: searchBarProps.privateCarNum,
    value: nextCarNum,
  });
}

function hasSubmitProp() {
  return Object.keys(props).find((key) => {
    return key.startsWith('onSubmit') && typeof props[key] === 'function';
  });
}

function onSubmit() {
  if (searchBar.value.privateCarNum.length < 7) {
    store.commit("openMessageBox", "차량번호를 확인하세요.");
    return;
  }

  if (!hasSubmitProp()) {
    store.commit('updateDateRangeGroup');
    return;
  }

  processSubmits(store, props, searchBar.value);
}

async function loadInitialData() {
  await initSearchBar({
    autoSelectDriver: false,
    showPayType: false,
    secondaryStyle: props.secondaryStyle,
    strictHourByOffice: false,
    syncTime: false,
  });
  store.commit('updateDateRangeGroup');
}

onMounted(loadInitialData)

</script>
